import { useEffect, useRef, useState } from "react";
import MenuPage from "../menu-page/menu-page";
import { constants } from "../../../constants";
import header from "../../../images/supportheader.gif";
import { useToken } from "../../../authToken";
import RoomAPI from "../../../RoomAPI";

type SyncState = "loading" | "synced" | "error";

const Thankyou = () => {
  const token = useToken();
  const [syncState, setSyncState] = useState<SyncState>("loading");
  const ran = useRef(false);

  const runSync = (t: string) => {
    setSyncState("loading");
    RoomAPI.SyncStripeStatus(t)
      .then(() => setSyncState("synced"))
      .catch((e) => {
        console.error("Stripe sync error:", e);
        setSyncState("error");
      });
  };

  useEffect(() => {
    if (ran.current || !token) return;
    ran.current = true;
    runSync(token);
  }, [token]);

  return (
    <MenuPage titles={["thanks for supporting frantic fanfic"]} hideAvatar>
      <div>
        <img src={header} alt={"support us styled-header"} />
      </div>

      <div
        className={
          "flex-grow flex justify-center items-center flex-col space-y-4"
        }
      >
        {syncState === "loading" && !token && (
          <div className={"text-xl px-2 text-center text-yellow-500"}>
            please log in to activate your supporter features.
          </div>
        )}

        {syncState === "loading" && token && (
          <div className={"text-xl px-2 text-center"}>
            confirming your purchase...
          </div>
        )}

        {syncState === "error" && (
          <div className={"text-xl px-2 text-center text-red-500"}>
            we had trouble confirming your purchase. your payment was received
            —{" "}
            <button
              className={"underline"}
              onClick={() => token && runSync(token)}
            >
              try again
            </button>
            , or contact support if features don't appear.
          </div>
        )}

        <div
          className={"self-center flex flex-col m-4 justify-center text-2xl"}
        >
          <div className={"bg-gray-drk shadow-basic border-black border-[1px]"}>
            <div className={"bg-black text-white text-center leading-loose"}>
              enjoy your features!
            </div>
            <div className={"px-2"}>
              {constants.rightButton} PROMPT PACKS UNLOCKED.
            </div>
            <div className={"px-2"}>
              {constants.rightButton} ALL THEMES UNLOCKED.
            </div>
            <div className={"px-2"}>
              {constants.rightButton} THE FRANTIC FANFIC ZINE.
            </div>
            <div className={"px-2"}>
              {constants.rightButton} SUPPORTER AVATARS (MORE TO COME).
            </div>
            <div className={"px-2"}>
              {constants.rightButton} GUILT-FREE AD-FREE FRANTIC FANFIC!
            </div>
          </div>
        </div>

        <div className={"text-xl px-2 text-center"}>
          refresh the site for your features to take effect.
        </div>
        <div className={"text-xl px-2 text-center"}>
          follow us on bluesky{" "}
          <a href={"https://bsky.app/profile/franticfanfic.com"}>
            @FRANTICFANFIC.COM
          </a>{" "}
          :)
        </div>
      </div>
    </MenuPage>
  );
};

export default Thankyou;
